/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, DIPUNTO){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	// メインスライド
	const mainSlider = () => {
		if($('.js-mainSlider').length) {
			$('.js-mainSlider').slick({
				infinite: true,
				speed: 3000,
				autoplay: true,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				fade: true,
				arrows: false,
				dots: true,
				pauseOnFocus: false,
			});
		}
	}

	// NEWSモーダル
	const newsModal = () => {
		const $modal = $('#newsModal');
		const $modalImage = $('#newsModalImage');
		const $modalDate = $('#newsModalDate');
		const $modalTitle = $('#newsModalTitle');
		const $modalText = $('#newsModalText');
		let $triggerElement = null;
		let scrollTopNow = 0; // スクロール位置を保存

		// スクロールバーの幅を取得
		const getScrollbarWidth = () => {
			return window.innerWidth - document.documentElement.clientWidth;
		};

		// モーダルを閉じる共通処理
		const closeModal = () => {
			$modal.removeClass(v);
			setTimeout(() => {
				$modal.removeClass(a);
				$('html').css('overflow-y', '');
				$('body').css('padding-right', '');
				$(window).scrollTop(scrollTopNow); // スクロール位置を復元
				if ($triggerElement) {
					$triggerElement.focus();
					$triggerElement = null;
				}
			}, 400);
		};

		// モーダルを開く
		$(document).on('click', '.js-newsModal', function(e) {
			e.preventDefault();
			$triggerElement = $(this);
			const $item = $(this).closest('.top-news__item');
			const imageSrc = $item.find('.top-news__item-thumb img').attr('src');
			const date = $item.find('.top-news__item-date').text();
			const title = $item.find('.top-news__item-title').html();
			const summary = $item.find('.top-news__item-summary').html();

			$modalImage.attr('src', imageSrc);
			$modalDate.text(date);
			$modalTitle.html(title);
			$modalText.html(summary || '');

			scrollTopNow = $(window).scrollTop(); // 現在のスクロール位置を保存

			// スクロールバー幅分のpadding-rightを付与してガタつきを防止
			const scrollbarWidth = getScrollbarWidth();
			$('html').css('overflow-y', 'hidden');
			$('body').css('padding-right', scrollbarWidth + 'px');

			$modal.addClass(a);
			setTimeout(() => {
				$modal.addClass(v);
			}, 10);
		});

		// モーダルを閉じる
		$(document).on('click', '.js-newsModalClose', function() {
			closeModal();
		});

		// ESCキーで閉じる
		$(document).on('keydown', function(e) {
			if (e.key === 'Escape' && $modal.hasClass(a)) {
				closeModal();
			}
		});
	}

	// =============================================
	mainSlider();
	newsModal();

})(window.jQuery, window.DIPUNTO);